export const environment = {
  key: 'dev',
  production: false,
  googleAuthClientId: '1043563509958-e65moftnf7mot05pkcaeffe3orqg0pgo.apps.googleusercontent.com',
  baseUrl: 'https://dev.njo.internal.noovle.com',
  buildTimestamp: '2025-07-02 15.13.46 UTC',
  microsoft:{
    clientId: '0c564f0d-82c3-4640-8043-2627e736ebe0',
    tenantId: 'https://login.microsoftonline.com/6815f468-021c-48f2-a6b2-d65c8e979dfb'
  }
};
